import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { CacheService } from '../../shared/services/cache.service';
import { ProductStats } from '../models/ProductStats';
import * as moment from 'moment-timezone';


@Injectable()
export class ProductStatsService {
  private apiUrl = APP_SETTINGS.PaymentTransactionApiUrl;

  constructor(
    private executeService: ExecuteService,
    private cacheService: CacheService,
    private errorHandler: ErrorHandlerService) { }

  public Get(dateUtc: moment.moment): Observable<ProductStats[]> {
    const url = `${this.apiUrl}/stats?dateUtc=${dateUtc.toISOString()}`;

    return this.executeService.ExecuteWithToken('get', url)
      .pipe(
        catchError(this.errorHandler.handleAndThrowError<ProductStats[]>('Could not get active users stats', []))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/paymentTransactions/services/productStats.service.ts